import { dissocDotPath } from 'ramda-extension';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { createFetchState, getLastRequest, getMetaData, updateData } from './model';

const initialState = {};

const fetchReducerMap = {
	[types.FETCH_REQUEST]: (state, action) => {
		const { path, replaceParams, queryParams, body } = action.payload;
		const metaData = getMetaData(path)(state);
		const lastRequest = {
			replaceParams,
			queryParams,
			body,
		};
		const fetchState = createFetchState(true, false, false, metaData, lastRequest);
		return updateData(path, fetchState, state);
	},

	[types.FETCH_ON_SUCCESS]: (state, action) => {
		const { path, metaData } = action.payload;
		const lastRequest = getLastRequest(path)(state);
		return updateData(path, createFetchState(false, true, false, metaData, lastRequest), state);
	},

	[types.FETCH_ON_ERROR]: (state, action) => {
		const { path, data } = action.payload;
		const lastRequest = getLastRequest(path)(state);
		return updateData(path, createFetchState(false, false, true, data, lastRequest), state);
	},

	[types.FETCH_UPDATE_METADATA]: (state, action) => {
		const { path, metaData } = action.payload;
		const lastRequest = getLastRequest(path)(state);
		return updateData(path, createFetchState(false, true, false, metaData, lastRequest), state);
	},

	[types.FETCH_CLEAR]: (state, action) => {
		const { path } = action.payload;
		if (path) {
			return dissocDotPath(path, state);
		} else {
			return initialState;
		}
	},
};

export default handleActions(fetchReducerMap, initialState);
